
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Home } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-6">
      <div className="text-center max-w-lg mx-auto">
        <div className="w-24 h-24 rounded-2xl bg-yellow-300 flex items-center justify-center mx-auto mb-8">
          <div className="text-6xl font-montserrat font-bold text-darkgray">404</div>
        </div>
        <h1 className="text-4xl font-montserrat font-bold text-darkgray mb-4">Sidan hittas inte</h1>
        <p className="text-xl text-darkgray mb-8 font-opensans">
          Tyvärr kunde vi inte hitta den sida du letar efter. Den kan ha flyttats eller tagits bort.
        </p>
        <a 
          href="/" 
          className="btn-primary inline-flex items-center"
        >
          <Home className="mr-2 h-5 w-5" />
          Tillbaka till startsidan
        </a>
      </div>
    </div>
  );
};

export default NotFound;
